const menus = [
  {
    icon: 'home',
    title: '首页',
    path: '/',
    hidden () {
      return false
    }
  },
  {
    icon: 'team',
    title: '用户',
    path: '/model/user',
    hidden () {
      return false
    }
  }, {
    icon: 'user',
    title: '管理员',
    path: '/model/userAdmin',
    hidden () {
      return false
    }
  }, {
    icon: 'mobile',
    title: '大陆设备',
    path: '/model/facility',
    hidden () {
      return false
    }
  },
  {
    icon: 'mobile',
    title: '海外设备',
    path: '/model/overseas',
    hidden () {
      return false
    }
  }, {
    icon: 'radar-chart',
    title: '共享记录',
    path: '/model/share',
    hidden () {
      return false
    }
  }, {
    icon: 'database',
    title: '养宠指南',
    path: '/model/article',
    hidden () {
      return false
    }
  },
  {
    icon: 'android',
    title: '固件更新',
    path: '/model/updata',
    hidden () {
      return false
    }
  },
  {
    icon: 'message',
    title: '意见反馈',
    path: '/model/feedback',
    hidden () {
      return false
    }
  },
  {
    icon: 'setting',
    title: '基础设置',
    children: [{
      title: 'App配置',
      path: '/setting'
    }]
  }
]
export default menus
